import React from "react";
import ProductCard from "./ProductCard";
import "./CategorySection.css";

export default function CategorySection({
  category,
  onProductClick,
  onAddToCart,
  onDecreaseFromCart,
  getProductCartQty,
  getProductCartLineCount,
  tags,
  subcategoryRefs,
  highlightText,
  searchTerm,
  soldOutItems,
  isCartEnabled = false,
}) {
  // Group products by subCategoryName
  const productsBySubCategory = category.products.reduce((acc, product) => {
    const subCat = product.subCategoryName || ""; // empty string for products directly under parent
    if (!acc[subCat]) acc[subCat] = [];
    acc[subCat].push(product);
    return acc;
  }, {});

  return (
    <div className="category-section">
      {/* Parent Category Name */}
      <h2 className="category-title">{category.parentName}</h2>

      {/* Category Description */}
      {category.description && (
        <p className="category-description">{category.description}</p>
      )}

      {/* Products grouped by subcategory */}
      {Object.entries(productsBySubCategory).map(([subCatName, products]) => {
        // Create a unique key for this subcategory
        const subcategoryKey = subCatName ? `${category.id}-${subCatName}` : `${category.id}-default`;

        return (
          <div
            key={subCatName}
            ref={(el) => {
              if (subcategoryRefs && subCatName) {
                subcategoryRefs.current[subcategoryKey] = el;
              }
            }}
          >
            {subCatName && <h3 className="subcategory-title">{subCatName}</h3>}

            <div className="products-grid">
              {products.map((product) => (
                <ProductCard
                  key={product.id}
                  product={product}
                  tags={tags}
                  onClick={onProductClick}
                  onAddToCart={onAddToCart}
                  onDecreaseFromCart={onDecreaseFromCart}
                  cartQuantity={getProductCartQty ? getProductCartQty(product) : 0}
                  cartLineCount={getProductCartLineCount ? getProductCartLineCount(product) : 0}
                  highlightText={highlightText}
                  searchTerm={searchTerm}
                  isSoldOut={false}
                  isCartEnabled={isCartEnabled}
                />
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );
}
